import { useOffers } from "@nju/data-access-portal-offers";
import { MobileOfferDetails } from "@nju/feature-portal-offers";
import { Icon } from "@nju/icons";
import {
  BlockText,
  Drawer,
  Heading,
  Panel,
  Separator,
  Text,
  useOverlay,
} from "@nju/ui";

export function MultiDiscountBanner() {
  const drawer = useOverlay();
  const { mobile } = useOffers();
  const { indefiniteOffers } = mobile;
  const offer = indefiniteOffers.find((offer) => {
    return offer.display;
  });

  return (
    <>
      {drawer.isOpened && offer && (
        <Drawer onClose={drawer.close}>
          <MobileOfferDetails offer={offer} />
        </Drawer>
      )}
      <Panel
        forceShowTitleBlock={true}
        invisibleSeparator={true}
        separatorSize="none"
        testId="multi-discount-offer-banner"
      >
        <div className="h-full flex flex-col justify-between">
          <div>
            <Icon
              className="mr-3 w-6 h-6 from-tablet:w-8 from-tablet:h-8"
              name="badge-percent"
              tone="accent"
            />
            <Heading
              className="mt-4"
              font="ttfirs"
              tone="neutral"
              variant="h4"
              weight="bold"
            >
              {offer?.priceDiscountedAfterMobile} zł za każdy kolejny numer
            </Heading>
            <Separator size="xxs" tone="invisible" />
            <BlockText>
              <Text className="from-tablet:max-w-[330px]" size="l">
                Kup więcej numerów, by płacić {offer?.mobileMultiLineDiscount}{" "}
                zł/mies. za każdy kolejny numer.
              </Text>
            </BlockText>
          </div>
          <div>
            <span
              className="gap-3 mt-5 cursor-pointer flex items-center"
              onClick={drawer.open}
              role="button"
            >
              <Text tone="accent">sprawdź</Text>
              <Icon height={18} name="arrow-right" tone="accent" width={18} />
            </span>
          </div>
        </div>
      </Panel>
    </>
  );
}
